import { defaultColorPalette } from '@/constants/brandingThemes';
import { BankAccountStatus } from '@/types/bankAccounts';
import { Box, Typography } from '@mui/material';

type BankAccountStatusLabelProps = {
  status: BankAccountStatus;
  isSmall?: boolean;
};

export default function BankAccountStatusLabel({
  status,
  isSmall = false,
}: BankAccountStatusLabelProps) {
  const isActive = status === BankAccountStatus.Open;
  const isClosed = status === BankAccountStatus.Closed;
  const statusLabel = isActive ? 'Active' : isClosed ? 'Closed' : 'Locked';
  const statusColor = isActive
    ? defaultColorPalette.success
    : defaultColorPalette.error;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}>
      <Box
        sx={{
          backgroundColor: statusColor,
          height: isSmall ? 10 : 13,
          width: isSmall ? 10 : 13,
          borderRadius: '50%',
          marginRight: '5px',
          marginTop: '-3px',
        }}
      />
      <Typography variant={isSmall ? 'caption' : 'body1'}>
        {statusLabel}
      </Typography>
    </Box>
  );
}
